import React, { useContext, useState } from 'react';
import { useWizard } from 'react-use-wizard';
import { Button } from '../../util/buttons';
import { useTranslation } from 'react-i18next';
import ProjectFieldsPopover from '../components/ProjectFieldsPopover';
import CardStep from '../../wizard/CardStep';
import ProjectTemplateExportsTable from '../ProjectTemplateExportsTable';
import projectTemplateExportsService from '../project_template_exports.service';
export default function DownloadProjectDataStep(_ref) {
  let {
    claimGroup,
    stepConfig,
    NavigationContext
  } = _ref;
  const {
    goToStep
  } = useWizard();
  const navigationDirection = useContext(NavigationContext);
  const [selectedProjectFields, setSelectedProjectFields] = useState(window.MARKET_CONSTANTS.PROJECT_EXPORT_FIELDS_LIST);
  const [loading, setLoading] = useState(false);
  const {
    t
  } = useTranslation();
  const {
    exports,
    createExport
  } = projectTemplateExportsService.useCrud(setLoading, claimGroup.id);
  const goToDownloadDataStep = () => {
    navigationDirection.current = -1;
    goToStep(stepConfig['DownloadDataStep'].index);
  };
  const handleGenerateExport = async () => {
    setLoading(true);
    await createExport(selectedProjectFields);
    setLoading(false);
  };
  return /*#__PURE__*/React.createElement(CardStep, {
    title: "Select the fields you want to export",
    NavigationContext: NavigationContext
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center gap-3 mb-4 justify-content-center"
  }, /*#__PURE__*/React.createElement(ProjectFieldsPopover, {
    selectedProjectFields: selectedProjectFields,
    setSelectedProjectFields: setSelectedProjectFields
  }), /*#__PURE__*/React.createElement(Button, {
    onClick: handleGenerateExport,
    size: "md",
    variant: "info",
    iconPosition: "left",
    icon: "download",
    style: {
      width: '240px'
    },
    disabled: loading
  }, loading ? t('generating') : t('export_data'))), exports.length > 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("hr", {
    className: "my-3"
  }), /*#__PURE__*/React.createElement("h6", {
    className: "text-primary mb-3"
  }, t('export_history')), /*#__PURE__*/React.createElement(ProjectTemplateExportsTable, {
    exports: exports,
    loading: loading,
    userCanDelete: false
  })), /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between mt-auto pt-3"
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: goToDownloadDataStep
  }, "Go Back"))));
}